import { inject, Injectable } from '@angular/core';
import {
  getToken,
  isSupported,
  MessagePayload,
  Messaging,
  onMessage,
} from '@angular/fire/messaging';
import { Observable } from 'rxjs';
import { ToastService } from '../toast/toast.service';

const FCM_VAPID_KEY =
  'BDvcjMgDKHeIc7qhLpM32mnNwmxgBFHgFaVfY5F2i6obrxQpfqwrhLiYJ1WH0cwnPcmy3flSnVGdQ9Nm3elULcE';
const FCM_SERVICE_WORKER = '/assets/scripts/firebase-messaging-sw.js';

@Injectable({
  providedIn: 'root',
})
export class FCMService {
  private msg = inject(Messaging);

  private toast = inject(ToastService);

  message$ = new Observable<MessagePayload>(sub =>
    onMessage(this.msg, msg => sub.next(msg))
  );

  constructor() {
    this.message$.subscribe({
      next: msg => {
        if (msg.data?.['type'] === 'notification') {
          this.toast.showInfo(
            msg.data?.['title'] || 'New Notification',
            msg.data?.['body'] || ''
          );
        }
      },
      error: err => console.error('Error receiving message:', err),
    });
  }

  /**
   * FCM token of this browser if push is supported and permission was already
   * granted — never prompts the user. Returns null otherwise.
   */
  async getRegisteredToken(): Promise<string | null> {
    if (!(await isSupported())) {
      return null;
    }
    if (Notification.permission !== 'granted') {
      return null;
    }

    try {
      const serviceWorkerRegistration = await navigator.serviceWorker.register(
        FCM_SERVICE_WORKER,
        { type: 'module' }
      );
      return await getToken(this.msg, {
        vapidKey: FCM_VAPID_KEY,
        serviceWorkerRegistration,
      });
    } catch {
      return null;
    }
  }

  register() {
    return new Promise<string>((resolve, reject) => {
      Notification.requestPermission().then(
        (notificationPermissions: NotificationPermission) => {
          if (notificationPermissions === 'granted') {
            console.log('Granted');
          }
          if (notificationPermissions === 'denied') {
            console.log('Denied');
          }
        }
      );

      console.log('registering');
      navigator.serviceWorker
        .register(FCM_SERVICE_WORKER, {
          type: 'module',
        })
        .then(serviceWorkerRegistration => {
          getToken(this.msg, {
            vapidKey: FCM_VAPID_KEY,
            serviceWorkerRegistration: serviceWorkerRegistration,
          })
            .then(token => {
              resolve(token);
            })
            .catch(err => {
              reject(err);
            });
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
